export function roller(ctx) {
    return {
        styles: {
            // radius: 4 removed — was overriding ctx.pretty's radius (8, which
            // already matches lv_theme_material.c:209 bg style LV_DPX(8)) to an
            // INCORRECT 4. text_color removed — identical to ctx.pretty's own
            // text_color (REDUNDANT duplicate).
            main:     { ...ctx.pretty, text_font: 32 },
            selected: { bg_color: ctx.accent, text_color: '#ffffff' },
        },
    };
}
